import qs from 'query-string';
import xws from 'api/xws/';
import {
  ERROR_DAY_TIME,
  ERROR_FROM_CLUTCH
} from 'store/reducers/errors/actionTypes';

// Actions
import { getMetaVehicleId } from 'store/reducers/appointment/actions';
import { setFirstAvailableTimeSlot } from 'store/reducers/firstAvailableTimeSlot/actions';
import { ajaxCallbacks } from 'store/reducers/ajaxCall/actions';
import { setLastTimeslotSelected } from 'store/reducers/userInteractions/actions';

// Selectors
import { SET_AVAILABLE_TIMES } from './actionTypes';
import { getWebkey } from 'store/reducers/queryParams/selectors';
import {
  getMetaVehicleId as getMetaVehicleIdFromState,
  getAppointmentParams,
  getVehicle,
  getAdvisorId,
  getTransportationOption,
  getLeadTimeInDays
} from 'store/reducers/appointment/selectors';
import { getAvailableDays } from 'store/reducers/availableTimes/selectors';
import {
  getExternalValetProvider,
  isValetOrLoanerIntegration
} from 'store/reducers/dealerSettings/selectors';
import { getValetObjectDetails } from 'store/reducers/appointment/valetDetails/selectors';
import {
  getIsQuoteAppt,
  getQuoteConfirmationId,
  getFormattedQuotePackage,
  getFormattedQuoteServices
} from 'store/reducers/quoteAppt/selectors';
import { toISODate } from 'utils/string';

// Constants
import { getService } from 'constants/ajax';
import { TRANSPORTATION } from 'constants/transportation';
import { ERROR_TYPES } from 'constants/clutchValet';

// enums
import { WHOAMI } from 'constants/appConfig';

export function setAvailableTimes(availableTimes) {
  return {
    type: SET_AVAILABLE_TIMES,
    payload: availableTimes
  };
}

const { VALET, VALETLOANER } = TRANSPORTATION;

const getAvailableTimes = (serviceId, params, config) => async (
  dispatch,
  getState
) => {
  const transportationOption = getTransportationOption(getState());
  const vehicle = getVehicle(getState());
  if (!getMetaVehicleIdFromState(getState())) {
    await dispatch(getMetaVehicleId(vehicle));
  }
  const availableTimeService = getService(serviceId);
  const webkey = getWebkey(getState());
  const { autoRecallServices, ...apptParams } = getAppointmentParams(
    getState()
  );
  const recallLeadTimeDays = getLeadTimeInDays(getState());
  const isValet =
    transportationOption === VALET || transportationOption === VALETLOANER;
  availableTimeService.setPathVars({ webkey, serviceId });
  availableTimeService.setCallBacks(dispatch(ajaxCallbacks()));
  config && availableTimeService.setMasking(!!config.masking);
  const valetDetails = getValetObjectDetails(getState());
  const isExternalValet = isValet && !!getExternalValetProvider(getState());
  const isQuoteAppt = getIsQuoteAppt(getState());
  const quoteApptData = isQuoteAppt
    ? {
        quoteConfirmationCode: getQuoteConfirmationId(getState()),
        quoteServicePoint: JSON.stringify(getFormattedQuotePackage(getState())),
        quoteServices: JSON.stringify(getFormattedQuoteServices(getState()))
      }
    : {};

  const request = xws(availableTimeService).post(
    availableTimeService.getPath(),
    qs.stringify({
      ...params,
      ...apptParams,
      whoami: WHOAMI,
      recallLeadTimeDays,
      advisorId: isValetOrLoanerIntegration(getState())
        ? ''
        : getAdvisorId(getState()),
      transportationOption,
      vehicleId: vehicle.vehicleId ? vehicle.vehicleId : null,
      vin: null,
      pickupAddress: isExternalValet ? valetDetails.pickupAddress : '',
      dropoffAddress: isExternalValet ? valetDetails.dropoffAddress : '',
      ...quoteApptData
    })
  );

  try {
    const {
      data: { availableTimes }
    } = await request;
    if (availableTimes) {
      dispatch(setAvailableTimes(availableTimes));
    } else {
      if (isValetOrLoanerIntegration) {
        throw new Error(ERROR_TYPES.GENERIC_ERROR);
      } else {
        throw new Error('no available times');
      }
    }
  } catch (err) {
    const errorMessage = err.message || '';
    const errorCode = errorMessage
      .substring(errorMessage.lastIndexOf(':') + 1, errorMessage.length)
      .trim();

    // Verifies if the error code is from clutch
    if (
      Object.keys(ERROR_TYPES)
        .map(key => ERROR_TYPES[key])
        .indexOf(errorCode) >= 0
    ) {
      if (
        errorCode === ERROR_TYPES.NO_LOANER_AVAILABLE ||
        errorCode === ERROR_TYPES.GENERIC_ERROR
      ) {
        dispatch(setLastTimeslotSelected(null));
        dispatch(setAvailableTimes(null));
      }
      dispatch({
        type: ERROR_FROM_CLUTCH,
        payload: errorCode
      });
    } else {
      dispatch({
        type: ERROR_DAY_TIME,
        payload: true
      });
      /* eslint-disable no-console */
      console.log('error'); // TODO handling errors
      /* eslint-enable no-console */
    }
  }
};

export const getFirstAvailability = config => async (dispatch, getState) => {
  await dispatch(
    getAvailableTimes(
      'firstAvailable',
      {
        selectedDate: toISODate(new Date()),
        view: 'BIWEEKLY'
      },
      config
    )
  );
  dispatch(setFirstAvailableTimeSlot(getAvailableDays(getState())));
};

export const getAvailableTimesByDates = (
  selectedDate,
  endDate,
  config
) => async dispatch => {
  await dispatch(
    getAvailableTimes(
      'availableTimes',
      {
        selectedDate: toISODate(selectedDate),
        endDate: toISODate(endDate)
      },
      config
    )
  );
};



// WEBPACK FOOTER //
// ./src/store/reducers/availableTimes/actions.js